/**
 * Décide de l'intervalle de re-fetch « filet de sécurité » d'une requête TanStack.
 *
 * Le temps réel passe par Socket.IO (invalidation du cache sur chaque événement
 * + resync à la reconnexion, cf. useSocketSync). Le polling périodique n'est donc
 * utile QUE si le socket est tombé : connecté → pas de polling, déconnecté → on
 * re-fetch au délai donné pour ne jamais rester figé sans le savoir.
 */
export function fallbackRefetchInterval(connected: boolean, ms: number): number | false {
  return connected ? false : ms;
}
